// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__1Bzo8","tips":"style_tips__230u0","bindFace":"style_bindFace__2-Kqz","bindFaceBox":"style_bindFaceBox__1tjdR","userImage":"style_userImage__3KeD4"};